/** This is the single select form component type  */

export { default as SingleSelectField } from './single-select-field';
